import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { VisitReasonCreateDto, VisitReasonUpdateDto } from '../dtos/visitReason/visitReasonDto';

@Injectable({
  providedIn: 'root',
})
export class VisitReasonService {
  private apiUrl = `${environment.apiUrl}/VisitReason`;  // API base url

  constructor(private http: HttpClient) {}

  // Get all VisitReasons
  getAll(): Observable<any> {
    return this.http.get<any>(this.apiUrl);
  }

  //get by country Id
  getByCountryId(countryId: number): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/${countryId}`);
  }

  // Create a new VisitReason
  create(dto: VisitReasonCreateDto): Observable<void> {
    return this.http.post<void>(this.apiUrl, dto);
  }

  // Update an existing VisitReason
  update(id: number, dto: VisitReasonUpdateDto): Observable<void> {
    return this.http.put<void>(`${this.apiUrl}/${id}`, dto);
  }

  // Delete a VisitReason by Id
  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }
}
